module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-big01-517ba6b9a9d52d7f47f49b71ee4c8653.png";